module.exports = __webpack_public_path__ + "img/building-a-team.8f3746d0.png";